//LOGOS
import logo1 from "../Resourses/Logos/2025_60NGreenland.png";
import logo2 from "../Resourses/Logos/Air Greenland_2026_Logo.png";
import logo3 from "../Resourses/Logos/2025_Arctic_Law.png";
import logo4 from "../Resourses/Logos/2025_Arctic_Import.png";
import logo5 from "../Resourses/Logos/2025_Gorrissen_Federspie.png";
import logo6 from "../Resourses/Logos/2025_bws_shipping.png";
import logo7 from "../Resourses/Logos/2025_Danish_Industry.png";
import logo8 from "../Resourses/Logos/Greenland_Escape_2026_Logo.pdf.png"; // greenland escape
import logo9 from "../Resourses/Logos/2025_Greenland_Travel.png";
import logo10 from "../Resourses/Logos/2025_Illit.png";
import logo11 from "../Resourses/Logos/2025_BMS.png";
import logo12 from "../Resourses/Logos/2025_ksms.png";
import logo13 from "../Resourses/Logos/2025_Greenland_Resources.png";
import logo14 from "../Resourses/Logos/HP Entreprenørmaskiner_2026_Logo.png"; // hp semler 
import logo16 from "../Resourses/Logos/BDO_2026_Logo.png"; // BDO update to new 
import logo17 from "../Resourses/Logos/2025_Lumina.png";
import logo18 from "../Resourses/Logos/EMJ Atcon_2026_Logo.png";
import logo19 from "../Resourses/Logos/2025_Pangaea.png";
import logo20 from "../Resourses/Logos/POLOG_2026_Logo.png"; // polog // transparent 
import logo21 from "../Resourses/Logos/Qeqertalik Business Council QBC_2026_Logo.png"; // qeqertalik business council
import logo22 from "../Resourses/Logos/Boman Qujan_2026_Logo.png"; // qujan arctic pr net
import logo24 from "../Resourses/Logos/2025_Gronlands_Banken.png"; 
import logo25 from "../Resourses/Logos/HK_Transport_2026_Logo.png"; 
import logo26 from "../Resourses/Logos/2025_Nuna_Law.png";
import logo27 from "../Resourses/Logos/Innovation_South_Greenland_2026_Logo.png"; // innovation south greenland 
import logo28 from "../Resourses/Logos/2025_Rambøll_Grønland_A_S.png";
import logo29 from "../Resourses/Logos/2025_UP_Front_Communication_GR.png";
import logo30 from "../Resourses/Logos/2025_Sikuki_Nuuk_Harbour.png";
import logo31 from "../Resourses/Logos/2025_Cowi.png";
import logo32 from "../Resourses/Logos/KNI_2026_Logo.png"; // KNI 
import logo33 from "../Resourses/Logos/2025_ral-logo-red.png";
import logo34 from "../Resourses/Logos/Kaya_2026_Logo.png"; // kaya partners 
import logo35 from "../Resourses/Logos/Kalaallit_2026_Logo.png"; // kalaallit // transparent
import logo36 from "../Resourses/Logos/2025_Greenland_Business_Association_(GE).png";
import logo37 from "../Resourses/Logos/2025_Nalik_Venture.png";
import logo38 from "../Resourses/Logos/2025_Tusass.png";
import logo39 from "../Resourses/Logos/2025_VR_Travel.png";
import logo40 from "../Resourses/Logos/Kirk_Larsen_2026_Logo.png"; // kirk larsen // transparent
import logo41 from "../Resourses/Logos/2025_Sermeq_Helicopters_A_S.png";
import logo42 from "../Resourses/Logos/GreenlandCopter_2026_Logo.png"; // greenland copter / Transparent
import logo43 from "../Resourses/Logos/Kommune_2026_Logo.png"; // kommune kujalleq // Transparent

//PDFS
import pdf1 from "../Resourses/PDFs/2025_60N.pdf";
import pdf2 from "../Resourses/PDFs/2025_Air_Greenland.pdf";
import pdf3 from "../Resourses/PDFs/Kirk_Larsen_2026_PDF.pdf"; // kirk larsen 
import pdf4 from "../Resourses/PDFs/Arctic_Import_2026_PDF.pdf"; // arctic import
import pdf5 from "../Resourses/PDFs/Arctic_Law_2026_PDF.pdf"; // artic law
import pdf6 from "../Resourses/PDFs/BDO_2026_PDF.pdf"; // BDO
import pdf7 from "../Resourses/PDFs/BWS_2026_PDF.pdf"; // BWS
import pdf8 from "../Resourses/PDFs/Gorrissen_Federspiel_2026_PDF.pdf"; // gorrissen 
import pdf9 from "../Resourses/PDFs/2025_Greenland_Travel.pdf";
import pdf10 from "../Resourses/PDFs/2025_Illit_Forsikringit.pdf";
import pdf11 from "../Resourses/PDFs/2025_BMS_Magasin.pdf";
import pdf12 from "../Resourses/PDFs/Greenland_Escape_2026_PDF.pdf"; // greenland escape 
import pdf13 from "../Resourses/PDFs/2025_Greenland_Resources.pdf";  
import pdf14 from "../Resourses/PDFs/HP_Semler_2026_PDF.pdf"; // hp semler
import pdf15 from "../Resourses/PDFs/Kalaallit_2026_PDF.pdf"; // kalaallit 
import pdf16 from "../Resourses/PDFs/Kaya_2026_PDF.pdf"; // kaya partners
import pdf17 from "../Resourses/PDFs/2025_NEW_Lumina.pdf";
import pdf18 from "../Resourses/PDFs/KSMS_2026_PDF.pdf"; // ksms
import pdf19 from "../Resourses/PDFs/Nalik_2026_PDF.pdf"; // nalik
import pdf20 from "../Resourses/PDFs/POLOG_2026_PDF.pdf"; // polog
import pdf21 from "../Resourses/PDFs/QBC_2026_PDF.pdf"; // qeqertalik
import pdf22 from "../Resourses/PDFs/Boman_Qujan_2026_PDF.pdf"; // qujan arctic pr net
import pdf24 from "../Resourses/PDFs/Gronlandsbanken_2026_PDF.pdf"; // Gronlandsbanken
import pdf26 from "../Resourses/PDFs/2025_nuna_law.pdf";
import pdf28 from "../Resourses/PDFs/Innovation_South_Greenland_2026_PDF.pdf"; // Innovation South Greenland 
import pdf29 from "../Resourses/PDFs/KNI_2026_PDF.pdf"; // KNI 
import pdf30 from "../Resourses/PDFs/2025_Sikuki.pdf";
import pdf31 from "../Resourses/PDFs/2025_NEW_COWI.pdf";
import pdf36 from "../Resourses/PDFs/2025_Greenland_Business_Association_(GE).pdf";
import pdf38 from "../Resourses/PDFs/Tusass_2026_PDF.pdf"; // Tusass
import pdf39 from "../Resourses/PDFs/2025_VR_Travel.pdf";
import pdf41 from "../Resourses/PDFs/2025_Sermeq_Helicopters.pdf";
import pdf42 from "../Resourses/PDFs/EMJ_2026_New_PDF.pdf"; // EMJ new pdf
import pdf43 from "../Resourses/PDFs/Ramboll_2026_PDF.pdf"; // ramboll 
import pdf44 from "../Resourses/PDFs/RAL_2026_PDF.pdf"; // RAL Royal Arctic Line 
import { getYear } from "../utils";

 

export const companies = [
  {
    name: "60North Greenland",
    logo: logo1,
    website: "https://www.60north.gl/en/",
    pdf: pdf1,
    type: "withmail",
    email: `lasse@60north.gl?subject=PDAC ${getYear()}`,
    id: 1
  },
  {
    name: "Air Greenland A/S",
    logo: logo2,
    website: "https://www.airgreenland.com/",
    pdf: pdf2,
    type: "withmail",
    email: `dmo@airgreenland.gl?subject=PDAC ${getYear()}`,
    id: 2
  },
  {
    name: "Arctic Law Greenland",
    logo: logo3,
    website: "https://arcticlawgreenland.gl/en/",
    pdf: pdf5,
    type: "withmail",
    email: `bk@alg.gl?subject=PDAC ${getYear()}`,
    id: 3
  },
  {
    name: "Arctic Import",
    logo: logo4,
    website: "https://www.arcticimport.uk/",
    pdf: pdf4,
    type: "withmail",
    email: `thj@arcticimport.dk?subject=PDAC ${getYear()}`,
    id: 4
  },
  {
    name: "Gorrissen Federspiel",
    logo: logo5,
    website: "https://gorrissenfederspiel.com/en/",
    pdf: pdf8,
    type: "withmail",
    email: `mm@gorrissenfederspiel.com?subject=PDAC ${getYear()}`,
    id: 5
  },
  {
    name: "Blue Water Shipping",
    logo: logo6,
    website: "https://www.bws.net/",
    pdf: pdf7,
    type: "withmail",
    email: `thal@bws.dk?subject=PDAC ${getYear()}`,
    id: 6
  },
  {
    name: "Confederation of Danish Industry",
    logo: logo7,
    website: "https://www.danskindustri.dk/english/",
    pdf: null,
    type: "withmail",
    email: `emmo@di.dk?subject=PDAC ${getYear()}`,
    id: 7
  },
  {
    name: "Greenland Travel",
    logo: logo9,
    website: "https://www.greenland-travel.com",
    pdf: pdf9,
    type: "withmail",
    email: `MLN@greenland-travel.gl;TM@greenland-travel.dk?subject=PDAC ${getYear()}`,
    id: 8
  },
  {
    name: "Illit Forsikringit Agentur A/S",
    logo: logo10,
    website: "http://illitforsikringit.gl/da/",
    pdf: pdf10,
    type: "withmail",
    email: `8nw@codan.dk?subject=PDAC ${getYear()}`,
    id: 9
  },
  {
    name: "BMS A/S",
    logo: logo11,
    website: "https://bms.dk/en",
    pdf: pdf11,
    type: "withmail",
    email: `khl@bms.dk?subject=PDAC ${getYear()}`,
    id: 10
  },
  {
    name: "KSMS ApS",
    logo: logo12,
    website: "https://ksms.gl",
    pdf: pdf18,
    type: "withmail",
    email: `kristian@ksms.gl;martin@ksms.gl?subject=PDAC ${getYear()}`,
    id: 11
  },
  {
    name: "Greenland Resources A/S",
    logo: logo13,
    website: "https://www.greenlandresources.ca/",
    pdf: pdf13,
    type: "withmail",
    email: `nb@greenlandresourcesinc.com?subject=PDAC ${getYear()}`,
    id: 12
  },
  {
    name: "BDO Statsautoriseret Revisionspartnerselskab",
    logo: logo16,
    website: "https://www.bdo.global/en-gb/home",
    pdf: pdf6,
    type: "withmail",
    email: `clbec@bdo.dk?subject=PDAC ${getYear()}`,
    id: 13
  },
  {
    name: "Lumina Sustainable Materials A/S",
    logo: logo17,
    website: "http://luminamaterials.com/",
    pdf: pdf17,
    type: "withmail",
    email: `bent@lumina.gl?subject=PDAC ${getYear()}`,
    id: 14
  },
  {
    name: "EMJ-Atcon Greenland A/S",
    logo: logo18,
    website: "https://www.emj-atcon.gl/",
    pdf: pdf42,
    type: "withmail",
    email: `dan@emj.gl?subject=PDAC ${getYear()}`,
    id: 15
  },
  {
    name: "Pangaea Logistics Solutions A/S",
    logo: logo19,
    website: "https://www.pangeals.com/",
    pdf: "https://noble.mediasite.com/Mediasite/Play/2283ad7a4bc44c348cb0ff556eaf08d71d",
    type: "withmail",
    email: `CAndersen@Pangaeals.com?subject=PDAC ${getYear()}`,
    id: 16
  },
  {
    name: "Grønlandsbanken A/S",
    logo: logo24,
    website: "https://banken.gl/en/business-customers/",
    pdf: pdf24,
    type: "withmail",
    email: `ss@banken.gl?subject=PDAC ${getYear()}`,
    id: 17
  },
  {
    name: "Nuna Law Firm ApS",
    logo: logo26,
    website: "http://www.nuna-law.com/?lang=en",
    pdf: pdf26,
    type: "withmail",
    email: `hk@nuna-law.gl?subject=PDAC ${getYear()}`,
    id: 18
  },
  {
    name: "Rambøll Grønland A/S",
    logo: logo28,
    website: "https://ramboll.com/contact/greenland",
    pdf: pdf43,
    type: "withmail",
    email: `inb@ramboll.gl?subject=PDAC ${getYear()}`,
    id: 19
  },
  {
    name: "UP Front Communication ApS",
    logo: logo29,
    website: "https://upfrontcom.dk/kontakt",
    pdf: null,
    type: "withmail",
    email: `hans.bak@mail.dk?subject=PDAC ${getYear()}`,
    id: 20
  },
  {
    name: "Sikuki Nuuk Harbour A/S",
    logo: logo30,
    website: "http://www.sikuki.com/",
    pdf: pdf30,
    type: "withmail",
    email: `jr@sikuki.gl?subject=PDAC ${getYear()}`,
    id: 21
  },
  {
    name: "COWI",
    logo: logo31,
    website: "https://www.cowi.com/",
    pdf: pdf31,
    type: "withmail",
    email: `jas@cowi.com;lbmn@cowi.com?subject=PDAC ${getYear()}`,
    id: 22
  },
  {
    name: "Royal Arctic Line A/S",
    logo: logo33,
    website: "https://www.royalarcticline.com/",
    pdf: pdf44,
    type: "withmail",
    email: `esb@ral.dk?subject=PDAC ${getYear()}`,
    id: 23
  },
  {
    name: "Kalaallit Forsikring A/S",
    logo: logo35,
    website: "https://www.forsikring.gl/web/gl/kalaallitdk.nsf",
    pdf: pdf15,
    type: "withmail",
    email: `dora.drechsel@if.gl?subject=PDAC ${getYear()}`,
    id: 24
  },
  {
    name: "Greenland Business Association",
    logo: logo36,
    website: "http://ge.ga.gl/da-dk/Velkommen/English",
    pdf: pdf36,
    type: "withmail",
    email: `ga@ga.gl?subject=PDAC ${getYear()}`,
    id: 25
  },
  {
    name: "Nalik Ventures",
    logo: logo37,
    website: "http://www.nalik.gl/",
    pdf: pdf19,
    type: "withmail",
    email: `tyt@nalik.gl?subject=PDAC ${getYear()}`,
    id: 26
  },
  {
    name: "Tusass",
    logo: logo38,
    website: "https://www.tusass.gl/en/",
    pdf: pdf38,
    type: "withmail",
    email: `mama@tusass.gl?subject=PDAC ${getYear()}`,
    id: 27
  },
  {
    name: "VR Travel Greenland",
    logo: logo39,
    website: "https://www.vr-travel.com",
    pdf: pdf39,
    type: "withmail",
    email: `np@vejle-rejser.gl?subject=PDAC ${getYear()}`,
    id: 28
  },
  {
    name: "Kirk Larsen & Ascanius Greenland",
    logo: logo40,
    website: "http://www.kirklarsen.gl",
    pdf: pdf3,
    type: "withmail",
    email: `kas@kirklarsen.gl?subject=PDAC ${getYear()}`,
    id: 29
  },
  {
    name: "Sermeq Helicopters A/S",
    logo: logo41,
    website: "https://www.sermeqhelicopters.gl/",
    pdf: pdf41,
    type: "withmail",
    email: `pilu@helicopter.gl?subject=PDAC ${getYear()}`,
    id: 30
  },
  {
    name: "GreenlandCopter",
    logo: logo42,
    website: "https://www.greenlandcopter.com/",
    pdf: null,
    type: "withmail",
    email: `thomas@greenlandcopter.com?subject=PDAC ${getYear()}`,
    id: 31
  },
  {
    name: "Greenland Escape ApS",
    logo: logo8,
    website: "https://www.greenland-escape.com",
    pdf: pdf12,
    type: "withmail",
    email: `connect@greenland-escape.com?subject=PDAC ${getYear()}`,
    id: 32
  },
  {
    name: "H.P. Semler Machinery A/S",
    logo: logo14,
    website: "https://www.semlermachinery.dk",
    pdf: pdf14,
    type: "withmail",
    email: `kenne@semlermachinery.dk?subject=PDAC ${getYear()}`,
    id: 33
  },
  {
    name: "HK Transport ApS",
    logo: logo25,
    website: "https://www.hktransport.gl/",
    pdf: null,
    type: "withmail",
    email: `mkn@hktransport.gl?subject=PDAC ${getYear()}`,
    id: 34
  },
  {
    name: "Innovation South Greenland A/S",
    logo: logo27,
    website: "https://www.isg.gl/en/home/",
    pdf: pdf28,
    type: "withmail",
    email: `info@isg.gl?subject=PDAC ${getYear()}`,
    id: 35
  },
  {
    name: "Kaya Research ApS",
    logo: logo34,
    website: "https://www.kayapartners.com",
    pdf: pdf16,
    type: "withmail",
    email: `nick.heilmann@kayapartners.com?subject=PDAC ${getYear()}`,
    id: 36
  },
  {
    name: "KNI",
    logo: logo32,
    website: "https://www.kni.gl/en/",
    pdf: pdf29,
    type: "withmail",
    email: `niz@kni.gl?subject=PDAC ${getYear()}`,
    id: 37
  },
  {
    name: "POLOG",
    logo: logo20,
    website: "https://www.polog.dk",
    pdf: pdf20,
    type: "withmail",
    email: `info@polog.dk?subject=PDAC ${getYear()}`,
    id: 38
  },
  {
    name: "Qeqertalik Business Council A/S",
    logo: logo21,
    website: "https://www.qbc.gl/en",
    pdf: pdf21,
    type: "withmail",
    email: `info@qbc.gl?subject=PDAC ${getYear()}`,
    id: 39
  },
  {
    name: "Qujan / Arctic PR Net",
    logo: logo22,
    website: "https://www.qujan.gl",
    pdf: pdf22,
    type: "withmail",
    email: `jb@boman.dk?subject=PDAC ${getYear()}`,
    id: 40
  },
  {
    name: "Kommune Kujalleq",
    logo: logo43,
    website: "https://www.kujalleq.gl/",
    pdf: null,
    type: "withmail",
    email: `rave@kujalleq.gl?subject=PDAC ${getYear()}`,
    id: 41
  },

];
